import { createSlice } from "@reduxjs/toolkit";
import {
  getVehicles,
  getVehiclesGetFilters,
  getVehiclesGetFiltersExport,
  getClientVehicles,
  addNewVehicle,
  updateVehicle,
  deleteVehicle,
} from "./thunk";

export const initialState = {
  vehicles: [],
  error: {},
  clientVehicles: [],

  vehiclesGetFilters: [],
  vehiclesGetFiltersExport: [],
  isVehiclesGetFiltersSuccess: false,
  isVehiclesGetFiltersFailed: false,
  isVehiclesGetFiltersExportSuccess: false,
  isVehiclesGetFiltersExporFailed: false,
  isLoadingGetFilters: false,
  isLoadingGetFiltersExport: false,
};

const vehiclesSlice = createSlice({
  name: "vehicle",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getVehicles.fulfilled, (state, action) => {
      state.vehicles = action.payload;
      state.isVehiclesFailed = false;
      state.isVehiclesSuccess = true;
    });

    builder.addCase(getVehicles.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isVehiclesFailed = true;
      state.isVehiclesSuccess = false;
    });

    //===========================================================================

    builder
      .addCase(getVehiclesGetFilters.pending, (state) => {
        state.isLoadingGetFilters = true;
        state.isVehiclesGetFiltersFailed = false;
        state.isVehiclesGetFiltersSuccess = false;
      })

      .addCase(getVehiclesGetFilters.fulfilled, (state, action) => {
        const {
          vehicles = [],
          totalStatusCounts = {},
          totalCount = 0,
          countsPerDate = {},
        } = action.payload || {};

        state.vehiclesGetFilters = vehicles;
        state.totalStatusCounts = totalStatusCounts;
        state.totalCount = totalCount;
        state.countsPerDate = countsPerDate;

        state.isLoadingGetFilters = false;
        state.isVehiclesGetFiltersFailed = false;
        state.isVehiclesGetFiltersSuccess = true;
      })

      .addCase(getVehiclesGetFilters.rejected, (state, action) => {
        state.error =
          action.payload?.error ||
          action.error?.message ||
          "An unknown error occurred.";
        state.isLoadingGetFilters = false;
        state.isVehiclesGetFiltersFailed = true;
        state.isVehiclesGetFiltersSuccess = false;
      });

    //===========================================================================

    builder
      .addCase(getVehiclesGetFiltersExport.pending, (state) => {
        state.isLoadingGetFiltersExport = true;
        state.isVehiclesGetFiltersExportFailed = false;
        state.isVehiclesGetFiltersExportSuccess = false;
      })

      .addCase(getVehiclesGetFiltersExport.fulfilled, (state, action) => {
        const { vehicles = [], totalCount = 0 } = action.payload || {};

        state.vehiclesGetFiltersExport = vehicles;
        state.totalCount = totalCount;

        state.isLoadingGetFiltersExport = false;
        state.isVehiclesGetFiltersExportFailed = false;
        state.isVehiclesGetFiltersExportSuccess = true;
      })

      .addCase(getVehiclesGetFiltersExport.rejected, (state, action) => {
        state.error =
          action.payload?.error ||
          action.error?.message ||
          "An unknown error occurred.";
        state.isLoadingGetFiltersExport = false;
        state.isVehiclesGetFiltersExportFailed = true;
        state.isVehiclesGetFiltersExportSuccess = false;
      });

    //===========================================================================

    builder.addCase(addNewVehicle.fulfilled, (state, action) => {
      state.vehicles.push(action.payload);
      state.isVehicleAdd = true;
      state.isVehicleAddFail = false;
    });

    builder.addCase(addNewVehicle.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isVehicleAdd = false;
      state.isVehicleAddFail = true;
    });

    builder.addCase(updateVehicle.fulfilled, (state, action) => {
      state.vehicles = state.vehicles.map((vehicle) =>
        vehicle._id.toString() === action.payload._id.toString()
          ? { ...vehicle, ...action.payload }
          : vehicle
      );
      state.isVehicleUpdate = true;
      state.isVehicleUpdateFail = false;
    });

    builder.addCase(updateVehicle.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isVehicleUpdate = false;
      state.isVehicleUpdateFail = true;
    });

    builder.addCase(deleteVehicle.fulfilled, (state, action) => {
      state.vehicles = (state.vehicles || []).filter(
        (vehicle) =>
          vehicle._id.toString() !== action.payload.vehicle.toString()
      );
      state.isVehicleDelete = true;
      state.isVehicleDeleteFail = false;
    });

    builder.addCase(deleteVehicle.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isVehicleDelete = false;
      state.isVehicleDeleteFail = true;
    });

    builder.addCase(getClientVehicles.fulfilled, (state, action) => {
      state.clientVehicles = action.payload;
      state.isVehiclesFailed = false;
      state.isVehiclesSuccess = true;
    });

    builder.addCase(getClientVehicles.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isVehiclesFailed = true;
      state.isVehiclesSuccess = false;
    });
  },
});

export default vehiclesSlice.reducer;
